import React, { Component, createRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import moment from "moment";
import ProductionPMSlipModel from "../../components/production/ProductionPMSlip.js";

class PackingRequisitionPrint extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.productionServices = new ProductionServices();
    this.state = {
      setRMSlipModel: false,
      isPrintButtonHide: false,
      pmFormulaList: [],
      tableStatus: "",
      filterDetails: {
        orderNumber: "",
        productName: "",
        filterBy: "productionNo",
        productionStageId: [4, 5]
      },
      productionRequisitionList: [],
      packingDetails: {
        productDetialsId: "",
        productionNo: "",
        batchNo: "",
        batchSize: "",
        stdBatchSize: "",
        productId: "",
        mfgDate: "",
        expDate: "",
        size: "",
        colour: "",
        productionStageStatusId: 0,
        packingItemId: "",
        packQty: 0,
        packingRequisitionReqDate: "",
      },
      filterByList: [
        { filterBy: "Prod No.", value: "productionNo" },
        { filterBy: "Batch No", value: "batchNo" },
        { filterBy: "Batch Size", value: "batchSize" },
      ],
    };
  }

  componentDidMount() {
    this.getAllProductionPlanningEntry();
  }

  getAllProductionPlanningEntry = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices
      .getAllProductionPlanningEntry(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let res = response.responseData;
          this.setState({ productionRequisitionList: res });
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllProductionPlanningEntry()
      });
    }
  };

  handleDropDownChange = (event, name) => {
    const select = event.target.value;
    if (select !== "Select") {
      let details = this.state.filterDetails;
      details[name] = select;
      this.setState({ filterDetails: details }, () => {
        this.getAllProductionPlanningEntry()
      });
    }
  };

  getProductionPlanningEntryById = (id) => {
    this.productionServices
      .getProductionPlanningEntryById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = this.state.packingDetails;
          let res = response.responseData;
          details.productionNo = res.productionNo;
          details.batchNo = res.batchNo;
          details.batchSize = res.batchSize;
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productName = res.productId ? res.productId.productName : "";
          details.productId = res.productId ? res.productId._id : "";
          details.size = res.productId ? res.productId.sizeName : "";
          details.colour = res.productId ? res.productId.color : "";
          details.productDetialsId = res._id ? res._id : "";
          details.mfgDate = res.mfgDate
            ? moment(res.mfgDate).format("yyyy-MM-DD")
            : "";
          details.expDate = res.expDate
            ? moment(res.expDate).format("yyyy-MM-DD")
            : "";
          details.packingRequisitionReqDate = res.packingRequisitionReqDate
            ? moment(res.packingRequisitionReqDate).format("yyyy-MM-DD")
            : "";
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productionStageStatusId =
            res.productionStageStatusId.productionStageId;
          details.packingItemId = res.packingItemId ? res.packingItemId : "";
          details.packQty = res.packQty;

          this.setState({ packingDetails: details, isGridView: false }, () => {
            if (this.state.packingDetails.productionStageStatusId >= 4) {
              this.getProductionPMFOrmulaByProductionDetailsId(
                this.state.packingDetails.productDetialsId
              );
            }
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  getProductionPMFOrmulaByProductionDetailsId = (id) => {
    this.productionServices
      .getProductionPMFOrmulaByProductionDetailsId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let array = response.responseData;
          this.setState({ pmFormulaList: array, isGridView: false }, () => {
            this.setState({ setRMSlipModel: true })
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };


  printSlip = () => {
    this.setState({ setRMSlipModel: true });
  };

  setOpenModel = () => {
    this.setState({ setRMSlipModel: !this.state.setRMSlipModel });
  };

  printData = () => {
    // this.setState({ isPrintButtonHide: true }, () => {
    //   window.print();
    //   this.setState({ setRMSlipModel: false, isPrintButtonHide: false });
    // });

    const printContent = this.printRef.current;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();

    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  render() {
    return (
      <>
        <div className="PackingRequisitionPrint-page">
          {/* 1. Item search */}
          <div className="item-search">
            <div className="item-grp flex gap-[10px] mb-4">
              <div className="search-grp w-full">
                <label>Prod. No.</label>
                <input
                  type="text"
                  id="orderNumber"
                  name="orderNumber"
                  autoComplete="off"
                  className="inputFocus w-full"
                  value={this.state.filterDetails.orderNumber}
                  onChange={(event) =>
                    this.handleChange(event, "orderNumber", "filterDetails")
                  }
                />
              </div>
              <div className="search-grp w-full">
                <label>Product Name</label>
                <input
                  type="text"
                  id="productName"
                  name="productName"
                  autoComplete="off"
                  className="inputFocus w-full"
                  value={this.state.filterDetails.productName}
                  onChange={(event) =>
                    this.handleChange(event, "productName", "filterDetails")
                  }
                />
              </div>
              <div className="search-grp w-full">
                <label>Arranged By:</label>
                <select
                  name="filterBy"
                  className="w-full"
                  value={this.state.filterDetails.filterBy}
                  onChange={(event) =>
                    this.handleDropDownChange(event, "filterBy", "filterDetails")
                  }
                >
                  <option>Select</option>
                  {this.state.filterByList.map((x, key) => (
                    <option key={key} value={x.value}>
                      {x.filterBy}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* 2. Item tabel  */}
          <div className="itemList-table">
            <div className="table-container" style={{ height: "calc(100vh - 125px)" }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td className="w-[10%]">Prod No.</td>
                    <td className="w-[20%]">Product Name</td>
                    <td className="w-[15%]">Batch No.</td>
                    <td className="w-[15%]">Bt. Size</td>
                    <td className="w-[15%]">Mfg. Date</td>
                    <td className="w-[15%]">Exp. Dt.</td>
                    <td className="w-[10%]" style={{ textAlign: "center" }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.productionRequisitionList && this.state.productionRequisitionList.length > 0
                    ? this.state.productionRequisitionList.map((item, key) => (
                      <tr key={key}>
                        <td>{item.productionNo}</td>
                        <td>{item.productId.productName}</td>
                        <td>{item.batchNo}</td>
                        <td>{item.batchSize}</td>
                        <td>{moment(item.mfgDate).format("DD MMM yyyy")}</td>
                        <td>{moment(item.expDate).format("DD MMM yyyy")}</td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            className="print-btn"
                            onClick={() =>
                              this.getProductionPlanningEntryById(
                                item._id
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faPrint} />
                          </button>
                        </td>
                      </tr>
                    ))
                    : this.state.productionRequisitionList &&
                      this.state.productionRequisitionList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.productionRequisitionList &&
                      this.state.productionRequisitionList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ProductionPMSlipModel
          setRMSlipModel={this.state.setRMSlipModel}
          setModalOpen={this.setOpenModel.bind(this)}
          isPrintButtonHide={this.state.isPrintButtonHide}
          printData={this.printData.bind(this)}
          pmFormulaList={this.state.pmFormulaList}
          packingDetails={this.state.packingDetails}
          printRef={this.printRef}
        />
      </>
    );
  }
}

export default PackingRequisitionPrint;
